var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackMini = function SvgBackMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18558 5.88883C5.18558 5.2445 5.71634 4.72217 6.37106 4.72217H13.8791C14.5338 4.72217 15.0646 5.2445 15.0646 5.88883V14.8333C15.0646 15.4776 14.5338 15.9999 13.8791 15.9999H6.37106C5.71634 15.9999 5.18558 15.4776 5.18558 14.8333V5.88883Z",
    fill: "#00A5B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.9444C4 10.5148 4.35384 10.1666 4.79032 10.1666H15.4597C15.8962 10.1666 16.25 10.5148 16.25 10.9444V13.6666C16.25 14.0962 15.8962 14.4444 15.4597 14.4444H4.79032C4.35384 14.4444 4 14.0962 4 13.6666V10.9444Z",
    fill: "#00A5B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2741 7.44444C14.2741 8.30355 13.5665 9 12.6935 9L7.5564 9C6.68343 9 5.97575 8.30355 5.97575 7.44444L5.97576 4.72222L6.76608 4.72222L6.76608 7.44444C6.76608 7.874 7.11992 8.22222 7.5564 8.22222L12.6935 8.22222C13.13 8.22222 13.4838 7.874 13.4838 7.44444L13.4838 4.72222L14.2741 4.72222L14.2741 7.44444Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9033 4.72222V4.52778C11.9033 3.56128 11.1072 2.77778 10.1251 2.77778C9.14298 2.77778 8.34684 3.56128 8.34684 4.52778V4.72222H11.9033ZM10.1251 2C8.7065 2 7.55652 3.13172 7.55652 4.52778V5.5H12.6936V4.52778C12.6936 3.13172 11.5436 2 10.1251 2Z",
    fill: "#00A5B9"
  })));
};
export default SvgBackMini;